
<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<div *ngIf="$.row.discount_type=='Percentage'">
  <i class="fa fa-percentage text-600"></i>
</div>
<div *ngIf="$.row.discount_type=='Value'"><i
  class="fa fa-dollar text-600"></i>
</div>

</ng-container>
